export default [
    {
		path: '/account',
		name: 'Account',
		meta: { 
			requiresAuth: true,
			section: 'account'
		},
		component: () => import('@/views/account/Account'),
    },
	
]

